import { pushEventInfo, pushPageErrorInfo } from '../analytics';
import { buildFulfillmentTypeSettings } from '../shared/analytics';
import { FULFILLMENT_TYPE } from '../../constants/status';

export const TrackEditDeliveryAddressAnalytics = (
  settings: string | undefined,
  category: 'button submission' | 'overlay',
  fulfillmentType?: FULFILLMENT_TYPE,
  eventName = 'my account settings',
) => {
  pushEventInfo({
    category: { primaryCategory: category },
    eventInfo: { eventName },
    ...(settings && {
      myAccount: {
        settings,
      },
    }),
    ...(fulfillmentType && {
      fulfillmentType: buildFulfillmentTypeSettings(fulfillmentType),
    }),
  });
};

export const TrackErrorPageEditDeliveryAddressAnalytics = (
  pageSection: string,
  message: string,
  code = 'n/a',
) => {
  const pageError = {
    type: 'system',
    displayType: 'inline',
    pageSection,
    message,
    code,
  };
  pushPageErrorInfo(pageError);
};

export const TrackErrorEventEditDeliveryAddressAnalytics = (
  pageSection: string,
  errCode: string,
  errMessage: string,
  type: 'system' | 'error' | 'advisory',
  displayType = 'inline',
) => {
  pushEventInfo({
    category: {
      primaryCategory: 'error',
    },
    eventInfo: {
      eventName: 'post page error',
      error: [
        {
          type,
          displayType,
          pageSection,
          code: errCode,
          message: errMessage,
        },
      ],
    },
  });
};
